module.exports = __webpack_public_path__ + "img/_54A6741_t.1101ea54.jpg";